import { defineStore, acceptHMRUpdate } from "pinia";
import apolloClient from "../plugins/apollo";
import { addRecentPlayedTrack } from "@/gqls/mutations";
import { getRecentsTracks, GetUserLevels } from "@/gqls/auth";

export const useRecentStore = defineStore("recents", {
    state: () => ({
        recents: [], // Array to store favorite tracks
        level : null
    }),

    getters: {
        /**
         * Getter to retrieve all favorite tracks
         */
        getRecentsTracks: (state) => [...state.recents],
        getUserLevel : (state) =>state.level

    },

    actions: {
        /**
         * Add a single track to favorites
         * @param {Object} track - The track object of the track to be added
         */
        async addRecentTrackAction(track) {
            let trackId = track.id;
            
            return new Promise((resolve, reject) => {
                apolloClient
                    .mutate({
                        mutation: addRecentPlayedTrack,
                        variables: { trackId },
                    })
                    .then((response) => {
                        // Extract the recents from the response
                        let newTrack = response.data.addRecentTrack.recentTrack;

                        // Remove any existing entry for this track so it doesn't appear twice
                        const withoutDuplicate = this.recents.filter((recent) => recent.id !== newTrack.id);

                        // Add the track to the recents array
                        this.recents = [...withoutDuplicate, newTrack];

                        resolve(response);
                    })
                    .catch((error) => {
                        console.error("Error adding to recents:", error);
                        reject(error);
                    });
            });
        }
        ,



        /**
         * Fetch user recents tracks from the server
         * @param {Number} page - The page number for paginated results (default 1)
         * @param {Number} limit - The number of results per page (default 20)
         */
        async fetchRecentsAction(page = 1, limit = 6) {
            return new Promise((resolve, reject) => {
                apolloClient
                    .query({
                        query: getRecentsTracks,
                        fetchPolicy: "network-only",
                        variables: { page, limit },
                    })
                    .then((res) => {
                        this.recents = res.data.getUserRecentTracks.data; // Assuming `data` contains the array of tracks
                        resolve(this.favorites);
                    })
                    .catch((error) => {
                        console.error("Error fetching recents:", error);
                        reject(error);
                    });
            });
        },

         /**
         * Fetch user levels
         */
         async fetchUserLevelsAction() {
            return new Promise((resolve, reject) => {
                apolloClient
                    .query({
                        query: GetUserLevels,
                        fetchPolicy: "network-only",
                    })
                    .then((res) => {
                        this.level = res.data.me.user_points; // Assuming `data` contains the array of tracks
                        resolve(res);
                    })
                    .catch((error) => {
                        console.error("Error fetching user levels:", error);
                        reject(error);
                    });
            });
        },
    },
});

if (import.meta.webpackHot) {
    import.meta.webpackHot.accept(acceptHMRUpdate(useRecentStore, import.meta.webpackHot));
}
